// 菜单组件

import { Menu, message, Collapse } from 'antd';
import { useState, useEffect } from 'react'
import { ToolOutlined, AppstoreAddOutlined, HistoryOutlined } from '@ant-design/icons';
import fun from '../../common/common_fun'
import url from '../../common/url_config'
import common_data from './../../common/common_data'
import cookie from 'react-cookies'

const { SubMenu } = Menu
const { Panel } = Collapse

function App(props: any) {
  let EVK: any = [], POC: any = []
  let [loading, set_loading] = useState(false)//加载中
  let [menu_data, set_menu_data] = useState([])//恩智浦内部开发板菜单数据
  let [menu_data_partner, set_menu_data_partner] = useState([])//合作伙伴开发板菜单数据
  let [menu_data_seekfree, set_menu_data_seekfree] = useState([])//智能车大赛开发板菜单数据
  let [current_language_ch, set_current_language_ch] = useState(window.location.href.indexOf('?lan=en') === -1)//当前语言是否中文

  useEffect(() => {
    // 获取产品分类
    set_loading(true)
    fun['post_data'](url + 'get_boards_product_line_menu', {}).then(res => {
      if (res.status) {
        // console.log('查询分类数据', res.result)
        let internal_set: any = []
        let partner_set: any = []
        let seekfree_set: any = []
        res.result.map((item: any) => {
          if (item.owner === 'nxp') {
            internal_set.push(item)
          } else if (item.owner === 'seekfree') {
            seekfree_set.push(item)
          } else {
            partner_set.push(item)
          }
        })
        set_menu_data(internal_set)
        set_menu_data_partner(partner_set)
        set_menu_data_seekfree(seekfree_set)
        console.log('菜单数据', internal_set, partner_set, seekfree_set)
        cookie.save('left_menu_obj', JSON.stringify(res.result), { path: '/' })
      } else {
        message.error(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
      }
      set_loading(false)
    })

    // setTimeout(() => {
    //   let temp = document.getElementsByClassName('hardware_menu_left_box')
    //   console.log(temp[0])
    // }, 1000 * 3)
  }, [])

  return (
    <div className='hardware_menu_left_box' style={{}}>
      <div style={{ textIndent: 16, padding: '10px 0' }}>
        <a className='hardware_menu_title' style={{ fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.85)', fontSize: 16 }} href={'/product/overview' + (current_language_ch ? '' : '?lan=en')}><b>{current_language_ch ? '热门硬件预览' : 'Hot Hardware Overview'}</b></a>
      </div>
      <Collapse defaultActiveKey={['恩智浦开发板', '合作伙伴开发板', '智能车大赛专区']}>
        <Panel key='恩智浦开发板' header={current_language_ch ? '恩智浦开发板' : 'NXP Boards'}>
          <Collapse defaultActiveKey={['0', '1', '2', '3', '4', '5', '6', '7']}>
            {menu_data.map((item: any, index: number) => <Panel header={<span title={current_language_ch ? item.title_ch : item.title}>{current_language_ch ? item.title_ch : item.title}</span>} key={String(index)}>
              {item.children.map((item2: any, index2: number) => <div className='hardware_menu' key={index2}><a title={current_language_ch ? item2.title_ch : item2.title} href={'/product-' + common_data.url_board_match_set(item.title, false) + '/' + item2.format_url_board_product_category + (current_language_ch ? '' : '?lan=en')}>{current_language_ch ? (item2.title_ch || item2.title) : item2.title}</a></div>)}
            </Panel>)}
          </Collapse>
        </Panel>

        <Panel key='合作伙伴开发板' header={current_language_ch ? '合作伙伴开发板' : 'Partner Boards'}>
          <Collapse defaultActiveKey={['0', '1', '2', '3', '4', '5', '6', '7']}>
            {menu_data_partner.map((item: any, index: number) => <Panel header={<span title={current_language_ch ? item.title_ch : item.title}>{current_language_ch ? item.title_ch : item.title}</span>} key={String(index)}>
              {item.children.map((item2: any, index2: number) => <div className='hardware_menu' key={index2}><a title={current_language_ch ? item2.title_ch : item2.title} href={'/product-' + common_data.url_board_match_set(item.title, false) + '/' + item2.format_url_board_product_category + (current_language_ch ? '' : '?lan=en')}>{current_language_ch ? (item2.title_ch || item2.title) : item2.title}</a></div>)}
            </Panel>)}
          </Collapse>
        </Panel>

        <Panel key='智能车大赛专区' header={current_language_ch ? '智能车大赛专区' : 'Smart Car Competition Zone'}>
          <Collapse defaultActiveKey={['0', '1', '2', '3', '4', '5', '6', '7']}>
            {menu_data_seekfree.map((item: any, index: number) => <Panel header={<span title={current_language_ch ? item.title_ch : item.title}>{current_language_ch ? item.title_ch : item.title}</span>} key={String(index)}>
              {item.children.map((item2: any, index2: number) => <div className='hardware_menu' key={index2}><a title={current_language_ch ? item2.title_ch : item2.title} href={'/product-' + common_data.url_board_match_set(item.title, false) + '/' + item2.format_url_board_product_category + (current_language_ch ? '' : '?lan=en')}>{current_language_ch ? (item2.title_ch || item2.title) : item2.title}</a></div>)}
            </Panel>)}
          </Collapse>
        </Panel>
      </Collapse>
    </div>
  )
}

export default App